import { render, staticRenderFns } from "./AssemblyItemForm.vue?vue&type=template&id=1a1643a0&"
import script from "./AssemblyItemForm.vue?vue&type=script&lang=js&"
export * from "./AssemblyItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports